/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, DialogContentText, Grid } from '@material-ui/core';
import { Table, DialogDefault, DefaultFiltro } from '../../components';
import * as selectorsDrones from '../../store/drone/reducer';
import * as actionsDrones from '../../store/drone/actions';
import Formulario from './Formulario';

import * as Roles from '../../constants/role';
import * as selectorsAuth from '../../store/auth/reducer';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const Drones = ({ drones, loadDrones, deleteDrone, authData, exportDrone }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [titles] = useState(['Modelo', 'Série do drone', 'Série do rádio', 'Código SISANT', 'Código ANATEL', 'Inspetor']);
  const classes = useStyles();
  const [openExport, setOpenExport] = useState(false);
  const [localFilter, setLocalFilter] = useState({});

  const renderRows = r => {
    return (
      <>
        <TableCell>{r.modelo}</TableCell>
        <TableCell>{r.numSerieDrone}</TableCell>
        <TableCell>{r.numSerieRadio}</TableCell>
        <TableCell>{r.codigoSisant}</TableCell>
        <TableCell>{r.codigoAnatel}</TableCell>
        <TableCell>{r.inspetorName}</TableCell>
      </>
    )
  }

  useEffect(() => {
    loadDrones(localFilter)
  }, [loadDrones]);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onDelete = id => deleteDrone(id);
  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = (isSave) => {
    if (isSave) {
      loadDrones(localFilter);
    }
    setOpen(false);
    setId(null);
  }

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const getHeaderActions = () => {
    let actions = [];

    if (isAdmin()) {
      actions.push({ 
        title: 'Exportar',
        onClick: () => setOpenExport(true)
      });
    }

    return actions;
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <DefaultFiltro
            useCodigo
            codigoLabel='Modelo'
            useNumSerieDrone
            mdCodigo={2}
            xsCodigo={3}
            useInspetor
            mdInspetor={4}
            onFilter={filterData => {
              setLocalFilter(filterData);
              loadDrones(filterData);
            }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={drones}
          titles={titles}
          headerTitle="Drones"
          deleteMessage="A informação será removido e não poderá ser mais recuperado."
          renderRows={renderRows}
          onEdit={onEdit}
          onDelete={onDelete}
          onAdd={onAdd}
          hasRowActions={isAdmin()}
          hasAdd={isAdmin()}
          headerActions={getHeaderActions()}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
        />
        <DialogDefault
          open={openExport}
          useFullScreen={false}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            exportDrone(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
        </DialogDefault>
      </Grid>
    </>
  );
};

Drones.propTypes = {
  deleteDrone: PropTypes.func.isRequired,
  loadDrones: PropTypes.func.isRequired,
  drones: PropTypes.array,
  exportDrone: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  drones: selectorsDrones.getDrones(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsDrones
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Drones));